import { createLocalStorageHook } from '@/hooks/browser/createLocalStorageHook'
import { z } from 'zod'

export const useDepartureStation = createLocalStorageHook(
  'departure-station',
  z.string().optional()
)
